import { render, staticRenderFns } from "./TipoCrm.vue?vue&type=template&id=3d6833b4"
import script from "./TipoCrm.vue?vue&type=script&lang=ts"
export * from "./TipoCrm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports